import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import makeValidationSchema from './VesselInfoMakeValidationSchema'

const {
  form: {
    field: {
            CngTextField,
      CngDateField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: null,
  billNo: "",
  voyageNumber: "",
  carrierIdentifier: "",
  imoNumber: "",
  vesselName: "",
  vesselFlagCountry: "",
  vesselOwnershipIndicatorCode: "",
  vesselPowerTypeCode: "",
  vesselPowerTypeDescription: "",
  vesselLastForeignPort: "",
  vesselFirstUaePort: "",
  etdLastForeignPort: "",
  atdLastForeignPort: "",
  etaFirstUaeSeaport: ""
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, shouldHideMap }) {
  const { setValue } = useFormContext()
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let voyageNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VOYAGE_NUMBER)
    let carrierIdentifier = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.CARRIER_IDENTIFIER)
    let imoNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.IMO_NUMBER)
    let vesselName = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_NAME)
    let vesselFlagCountry = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_FLAG_COUNTRY)
    let vesselOwnershipIndicatorCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_OWNERSHIP_INDICATOR_CODE)
    let vesselPowerTypeCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_POWER_TYPE_CODE)
    let vesselPowerTypeDescription = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_POWER_TYPE_DESCRIPTION)
    let vesselLastForeignPort = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_LAST_FOREIGN_PORT)
    let vesselFirstUaePort = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_FIRST_UAE_PORT)
    let etdLastForeignPort = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.ETD_LAST_FOREIGN_PORT)
    let atdLastForeignPort = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.ATD_LAST_FOREIGN_PORT)
    let etaFirstUaeSeaport = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.ETA_FIRST_UAE_SEAPORT)

    return {
      voyageNumber,
      carrierIdentifier,
      imoNumber,
      vesselName,
      vesselFlagCountry,
      vesselOwnershipIndicatorCode,
      vesselPowerTypeCode,
      vesselPowerTypeDescription,
      vesselLastForeignPort,
      vesselFirstUaePort,
      etdLastForeignPort,
      atdLastForeignPort,
      etaFirstUaeSeaport
    }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="voyageNumber"
          label={translatedTextsObject.voyageNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 17 }}
          onChange={(e) => setValue("voyageNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="carrierIdentifier"
          label={translatedTextsObject.carrierIdentifier}
          disabled={disabled}
          codeType='UAE_MPCI_SMDG_CODE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="imoNumber"
          label={translatedTextsObject.imoNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 7 }}
          onChange={(e) => setValue("imoNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="vesselName"
          label={translatedTextsObject.vesselName}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 70 }}
          onChange={(e) => setValue("vesselName", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="vesselFlagCountry"
          label={translatedTextsObject.vesselFlagCountry}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 2 }}
          onChange={(e) => setValue("vesselFlagCountry", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="vesselOwnershipIndicatorCode"
          label={translatedTextsObject.vesselOwnershipIndicatorCode}
          disabled={disabled}
          codeType='UAE_MPCI_VESSEL_OWNERSHIP'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="vesselPowerTypeCode"
          label={translatedTextsObject.vesselPowerTypeCode}
          disabled={disabled}
          codeType='UAE_MPCI_VESSEL_POWER_TYPE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="vesselPowerTypeDescription"
          label={translatedTextsObject.vesselPowerTypeDescription}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 17 }}
          onChange={(e) => setValue("vesselPowerTypeDescription", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="vesselLastForeignPort"
          label={translatedTextsObject.vesselLastForeignPort}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 6 }}
          onChange={(e) => setValue("vesselLastForeignPort", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="vesselFirstUaePort"
          label={translatedTextsObject.vesselFirstUaePort}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 6 }}
          onChange={(e) => setValue("vesselFirstUaePort", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
            <CngGridItem xs={12} sm={6} lg={4}>
        <CngDateField
          name="etdLastForeignPort"
          label={translatedTextsObject.etdLastForeignPort}
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngDateField
          name="atdLastForeignPort"
          label={translatedTextsObject.atdLastForeignPort}
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngDateField
          name="etaFirstUaeSeaport"
          label={translatedTextsObject.etaFirstUaeSeaport}
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default FormProperties
